import { render, staticRenderFns } from "./BarraLateral.vue?vue&type=template&id=ccf67b2e&"
import script from "./BarraLateral.vue?vue&type=script&lang=ts&"
export * from "./BarraLateral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports